module.exports = __webpack_public_path__ + "img/MGH-Toyosu-12-2440x1172.228da8c6.jpg";